/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationRequestSubscriptionPaymentFrequency
 */
export interface CreateOrganizationRequestSubscriptionPaymentFrequency {
}

/**
 * Check if a given object implements the CreateOrganizationRequestSubscriptionPaymentFrequency interface.
 */
export function instanceOfCreateOrganizationRequestSubscriptionPaymentFrequency(value: object): value is CreateOrganizationRequestSubscriptionPaymentFrequency {
    return true;
}

export function CreateOrganizationRequestSubscriptionPaymentFrequencyFromJSON(json: any): CreateOrganizationRequestSubscriptionPaymentFrequency {
    return CreateOrganizationRequestSubscriptionPaymentFrequencyFromJSONTyped(json, false);
}

export function CreateOrganizationRequestSubscriptionPaymentFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequestSubscriptionPaymentFrequency {
    return json;
}

export function CreateOrganizationRequestSubscriptionPaymentFrequencyToJSON(json: any): CreateOrganizationRequestSubscriptionPaymentFrequency {
    return CreateOrganizationRequestSubscriptionPaymentFrequencyToJSONTyped(json, false);
}

export function CreateOrganizationRequestSubscriptionPaymentFrequencyToJSONTyped(value?: CreateOrganizationRequestSubscriptionPaymentFrequency | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

